import { useErpSurveySummaryQuery } from 'core/graphql';

import { ISurveySummary } from './surveyModel';

interface IUseSurveySummaryArgs {
  surveyId?: string;
  groupIds?: string[];
  planId?: string;
  dateFrom?: string;
  dateTo?: string;
}

interface ISurveySummaryHook {
  summary?: ISurveySummary;
  loading: boolean;
}

/**
 * Spec 0027 — pooled results across every group the survey is attached to.
 * The per-question numbers come from the same backend `_aggregate` the
 * per-assignment screen uses, so the two screens cannot disagree.
 */
export const useSurveySummary = ({
  surveyId,
  groupIds,
  planId,
  dateFrom,
  dateTo,
}: IUseSurveySummaryArgs): ISurveySummaryHook => {
  const { data, loading } = useErpSurveySummaryQuery({
    variables: {
      surveyId: surveyId as string,
      groupIds: groupIds && groupIds.length ? groupIds : undefined,
      planId,
      dateFrom,
      dateTo,
    },
    skip: !surveyId,
    fetchPolicy: 'cache-and-network',
  });

  return { summary: data?.surveySummary || undefined, loading };
};
